import { combineReducers } from 'redux';

import columnsReducer from './ducks/columns';
import containerReducer from './ducks/container';
import queryReducer from './ducks/query';


const reducers = {
  columns: columnsReducer,
  container: containerReducer,
  query: queryReducer,
};

export default combineReducers(reducers);
